import Lesson from './Lesson'

export default Lesson
